/**
 * 应收对账单相关打印变量
 */
const accountReceivableTempOptions = [
    {
        label: '应收对账单',
        value: 'all',
        children: [{ label: '应收对账单', value: 1 }],
    },
]
const accountReceivableTempJsonOptions = {
    all: {
        1: {
            "panels": [
                {
                    "index": 0,
                    "name": 1,
                    "height": 141,
                    "width": 210,
                    "paperHeader": 61.5,
                    "paperFooter": 387.49821428571425,
                    "printElements": [
                        {
                            "options": {
                                "left": 205,
                                "top": 5,
                                "height": 17,
                                "width": 219,
                                "right": 423.99373626708984,
                                "title": "对账单--XX配送中心",
                                "bottom": 22.74687957763672,
                                "hCenter": 14.24687957763672,
                                "vCenter": 314.49373626708984,
                                "fontSize": 16.5,
                                "testData": "",
                                "hideTitle": true,
                                "textAlign": "center",
                                "fontWeight": "700"
                            },
                            "printElementType": {
                                "title": "标题",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 190,
                                "top": 27.5,
                                "height": 15,
                                "width": 135,
                                "field": "beginDate",
                                "right": 371.25,
                                "title": "对账日期",
                                "bottom": 42,
                                "hCenter": 34.5,
                                "vCenter": 279.75,
                                "testData": "2023-08-01",
                                "formatter": "function(title,value,options,templateData,target){ return window.$dayjs(value).format('YYYY-MM-DD') }",
                                "qrCodeLevel": 0,
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 325,
                                "top": 27.5,
                                "height": 16.5,
                                "width": 18,
                                "right": 346.7500305175781,
                                "title": "-",
                                "bottom": 46.24999237060547,
                                "hCenter": 37.99999237060547,
                                "vCenter": 337.7500305175781
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 335,
                                "top": 27.5,
                                "height": 15,
                                "width": 76.5,
                                "field": "endDate",
                                "right": 453.50001525878906,
                                "title": "对账日期",
                                "bottom": 43.24999237060547,
                                "hCenter": 35.74999237060547,
                                "vCenter": 415.25001525878906,
                                "testData": "2023-10-01",
                                "formatter": "function(title,value,options,templateData,target){ return window.$dayjs(value).format('YYYY-MM-DD') }",
                                "hideTitle": true,
                                "qrCodeLevel": 0,
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 462.5,
                                "top": 27.5,
                                "height": 15,
                                "width": 130.5,
                                "field": "printTime",
                                "right": 604.0000305175781,
                                "title": "打印时间",
                                "bottom": 42.50001525878906,
                                "hCenter": 35.00001525878906,
                                "vCenter": 538.7500305175781,
                                "testData": "2023-04-06",
                                "qrCodeLevel": 0,
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 12.5,
                                "top": 27.5,
                                "height": 15,
                                "width": 169.5,
                                "field": "customerName",
                                "right": 181.5,
                                "title": "批发客户",
                                "bottom": 42,
                                "hCenter": 34.5,
                                "vCenter": 96.75,
                                "testData": "CGSS20230327000054",
                                "qrCodeLevel": 0,
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 189,
                                "top": 46.5,
                                "height": 15,
                                "width": 183,
                                "field": "usedPrepayAmt",
                                "right": 372.75,
                                "title": "合计预收款",
                                "bottom": 61.5,
                                "hCenter": 54,
                                "vCenter": 281.25,
                                "testData": "999.00",
                                "formatter": "function(value,options, templateData) {return (Number(options ) === 0 ? '0' : options)+ '元'}",
                                "qrCodeLevel": 0,
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 13.5,
                                "top": 67.5,
                                "height": 60,
                                "width": 553.5,
                                "field": "printLists",
                                "right": 570,
                                "bottom": 127.5,
                                "hCenter": 97.5,
                                "vCenter": 293.25,
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "groupFooterFormatter": "function(t,e){return\"这里自定义统计脚信息\";}",
                                "tableHeaderBackground": "#ffffff",
                                "columns": [
                                    [
                                        {
                                            "width": 37.095770037755024,
                                            "title": "序号",
                                            "field": "index",
                                            "checked": true,
                                            "columnId": "index",
                                            "fixed": false,
                                            "rowspan": 1,
                                            "colspan": 1
                                        },
                                        {
                                            "width": 84.69778117827084,
                                            "title": "业务日期",
                                            "field": "completeTime",
                                            "checked": true,
                                            "columnId": "completeTime",
                                            "fixed": false,
                                            "rowspan": 1,
                                            "colspan": 1,
                                            "formatter2": "function(value,row,index, options){ return window.$dayjs(row.completeTime).format('YYYY-MM-DD') }\n",
                                            "tableQRCodeLevel": 0,
                                            "tableSummaryTitle": true,
                                            "tableSummary": ""
                                        },
                                        {
                                            "width": 130.17938681876882,
                                            "title": "批发销货单号",
                                            "field": "sourceNo",
                                            "checked": true,
                                            "columnId": "sourceNo",
                                            "fixed": false,
                                            "rowspan": 1,
                                            "colspan": 1,
                                            "align": "left",
                                            "tableColumnHeight": "30",
                                            "tableTextType": "text",
                                            "tableBarcodeMode": "CODE128A",
                                            "tableQRCodeLevel": 0,
                                            "tableSummaryTitle": true,
                                            "tableSummaryText": "合计",
                                            "tableSummary": ""
                                        },
                                        {
                                            "width": 80.09101549130133,
                                            "title": "单据类型",
                                            "field": "sourceBillType",
                                            "checked": true,
                                            "columnId": "sourceBillType",
                                            "fixed": false,
                                            "rowspan": 1,
                                            "colspan": 1,
                                            "renderFormatter": "function(value,row,index,options){ \n    const sourceBillTypes = [\n        { \"label\": \"采购入库单\", \"value\": \"PURCHASE_RECEIVE_ORDER\" },\n        { \"label\": \"退货申请单\", \"value\": \"PURCHASE_RETURN_APPLY_ORDER\" },\n        { \"label\": \"采购退货单\", \"value\": \"PURCHASE_RETURN_ORDER\" }, \n        { \"label\": \"成本调整单\", \"value\": \"COST_ADJUST_ORDER\" }, \n        { \"label\": \"批发销货单\", \"value\": \"SALE_ORDER\" }, \n        { \"label\": \"退货单\", \"value\": \"SALE_RETURN_ORDER\" },\n        { \"label\": \"领用单\", \"value\": \"MATERIAL_RECEIVE_ORDER\" },\n        { \"label\": \"复核单\", \"value\": \"RECHECK_ORDER\" },\n        { \"label\": \"盈亏单\", \"value\": \"STOCK_BREAKAGE_ORDER\" },\n        { \"label\": \"系统调整单\", \"value\": \"SYS_COST_ADJUST_ORDER\" },\n        { \"label\": \"商品资料调整\",  \"value\": \"GOODS_ADJUST\" },\n        { \"label\": \"移仓单\", \"value\": \"WAREHOUSE_TRANSFER_ORDER\" },\n        { \"label\": \"采购订单\", \"value\": \"PURCHASE_ORDER\" },\n        { \"label\": \"补货请求单\", \"value\": \"DISTRIBUTION_REQUEST_ORDER\" },\n        { \"label\": \"批发订单\", \"value\": \"VERBAL_ORDER\" },\n        { \"label\": \"返点调整单\", \"value\": \"RATIO_AUDIT_ORDER\" },\n        { \"label\": \"基础售价调整单\", \"value\": \"PRICE_ADJUST_ORDER\" },\n        { \"label\": \"授信单\", \"value\": \"CUSTOMER_CREDIT_ORDER\" },\n        { \"label\": \"收款单\", \"value\": \"SETTLEMENT_ORDER\" },\n        { \"label\": \"折扣折让单\", \"value\": \"DISCOUNT_ORDER\" },\n        { \"label\": \"预收款单\", \"value\": \"PRE_PAY_ORDER\" },\n        { \"label\": \"应收对账单\", \"value\": \"RECONCILIATION_ORDER\" },\n        { \"label\": \"付款单\", \"value\": \"PAYMENT_ORDER\" }, \n        { \"label\": \"预付款单\", \"value\": \"PRE_PAYMENT_ORDER\" },\n        { \"label\": \"使用预付款\", \"value\": \"PAYMENT_ORDER_PRE_PAY\" },\n        { \"label\": \"本次折让\", \"value\": \"PAYMENT_ORDER_DISCOUNT\" },\n        { \"label\": \"使用预收款\", \"value\": \"SETTLEMENT_ORDER_PRE_PAY\" },\n        { \"label\": \"使用折扣折让\", \"value\": \"SETTLEMENT_ORDER_DISCOUNT\" },\n        { \"label\": \"盘点任务单\", \"value\": \"STOCK_CHECK_TASK\" },\n        { \"label\": \"盘点单\", \"value\": \"STOCK_CHECK_ORDER\" },\n        { \"label\": \"积分管理\", \"value\": \"CUSTOMER_REWARD_ORDER\" },\n        { \"label\": \"商品加工单\", \"value\": \"SKU_PROCESS_ORDER\" }\n    ]\n    return row?.sourceBillType && sourceBillTypes.find(item => item.value === row.sourceBillType)?.label || ''\n}\n",
                                            "tableColumnHeight": "30",
                                            "tableTextType": "text",
                                            "tableBarcodeMode": "CODE128A",
                                            "tableQRCodeLevel": 0,
                                            "tableSummaryTitle": true,
                                            "tableSummary": ""
                                        },
                                        {
                                            "width": 78.08251549130135,
                                            "title": "应收金额",
                                            "field": "balanceAmt",
                                            "checked": true,
                                            "columnId": "balanceAmt",
                                            "fixed": false,
                                            "rowspan": 1,
                                            "colspan": 1,
                                            "tableColumnHeight": "30",
                                            "tableTextType": "text",
                                            "tableBarcodeMode": "CODE128A",
                                            "tableQRCodeLevel": 0,
                                            "tableSummaryTitle": true,
                                            "tableSummary": ""
                                        },
                                        {
                                            "width": 63.94051549130134,
                                            "title": "收款金额",
                                            "field": "paymentAmt",
                                            "checked": true,
                                            "columnId": "paymentAmt",
                                            "fixed": false,
                                            "rowspan": 1,
                                            "colspan": 1,
                                            "renderFormatter": "function(value,row,index,options){ return (row?.paymentAmt || '--') }",
                                            "tableColumnHeight": "30",
                                            "tableTextType": "text",
                                            "tableBarcodeMode": "CODE128A",
                                            "tableQRCodeLevel": 0,
                                            "tableSummaryTitle": false,
                                            "tableSummary": "sum",
                                            "tableSummaryAlign": "right",
                                            "tableSummaryNumFormat": "2"
                                        },
                                        {
                                            "width": 79.41301549130134,
                                            "title": "备注",
                                            "field": "remark",
                                            "checked": true,
                                            "columnId": "remark",
                                            "fixed": false,
                                            "rowspan": 1,
                                            "colspan": 1,
                                            "tableColumnHeight": "30",
                                            "tableTextType": "text",
                                            "tableBarcodeMode": "CODE128A",
                                            "tableQRCodeLevel": 0,
                                            "tableSummaryTitle": false,
                                            "tableSummary": "",
                                            "tableSummaryAlign": "right",
                                            "tableSummaryNumFormat": "2"
                                        }
                                    ]
                                ]
                            },
                            "printElementType": {
                                "title": "表格",
                                "type": "table",
                                "editable": true,
                                "columnDisplayEditable": true,
                                "columnDisplayIndexEditable": true,
                                "columnTitleEditable": true,
                                "columnResizable": true,
                                "columnAlignEditable": true,
                                "isEnableEditField": true,
                                "isEnableContextMenu": true,
                                "isEnableInsertRow": true,
                                "isEnableDeleteRow": true,
                                "isEnableInsertColumn": true,
                                "isEnableDeleteColumn": true,
                                "isEnableMergeCell": true
                            }
                        },
                        {
                            "options": {
                                "left": 195,
                                "top": 140,
                                "height": 24,
                                "width": 124.5,
                                "right": 296.25,
                                "title": "本期销售",
                                "bottom": 262.5,
                                "hCenter": 240.75,
                                "vCenter": 234,
                                "fontSize": 14,
                                "testData": "CGSS20230327000054",
                                "borderTop": "solid",
                                "textAlign": "center",
                                "borderLeft": "solid",
                                "borderRight": "solid",
                                "qrCodeLevel": 0,
                                "borderBottom": "solid",
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 317.5,
                                "top": 140,
                                "height": 24,
                                "width": 124.5,
                                "right": 423,
                                "title": "收款",
                                "bottom": 261,
                                "hCenter": 239.25,
                                "vCenter": 360.75,
                                "fontSize": 14,
                                "borderTop": "solid",
                                "textAlign": "center",
                                "borderLeft": "solid",
                                "borderRight": "solid",
                                "qrCodeLevel": 0,
                                "borderBottom": "solid",
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 72.5,
                                "top": 140,
                                "height": 24,
                                "width": 124.5,
                                "right": 172.5,
                                "title": "上期欠款",
                                "bottom": 283.5,
                                "hCenter": 252,
                                "vCenter": 110.25,
                                "fontSize": 14,
                                "testData": "100009.45",
                                "borderTop": "solid",
                                "textAlign": "center",
                                "borderLeft": "solid",
                                "borderRight": "solid",
                                "qrCodeLevel": 0,
                                "borderBottom": "solid",
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 442.5,
                                "top": 140,
                                "height": 24,
                                "width": 124.5,
                                "right": 567.75,
                                "title": "累计欠款",
                                "bottom": 256.2421875,
                                "hCenter": 234.4921875,
                                "vCenter": 505.5,
                                "fontSize": 14,
                                "borderTop": "solid",
                                "textAlign": "center",
                                "borderLeft": "solid",
                                "borderRight": "solid",
                                "qrCodeLevel": 0,
                                "borderBottom": "solid",
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 25,
                                "top": 140,
                                "height": 48,
                                "width": 46.5,
                                "right": 73.5,
                                "title": "合计",
                                "bottom": 257.7421875,
                                "hCenter": 235.9921875,
                                "vCenter": 50.25,
                                "fontSize": 14,
                                "testData": "合计",
                                "borderTop": "solid",
                                "borderLeft": "solid",
                                "borderRight": "solid",
                                "qrCodeLevel": 0,
                                "borderBottom": "solid",
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 195,
                                "top": 162.5,
                                "height": 24,
                                "width": 124.5,
                                "field": "totalSaleAmt",
                                "right": 320.25,
                                "title": "上期欠款",
                                "bottom": 254.25,
                                "hCenter": 242.25,
                                "vCenter": 258,
                                "fontSize": 14,
                                "testData": "100009.45",
                                "borderTop": "solid",
                                "hideTitle": true,
                                "textAlign": "center",
                                "borderLeft": "solid",
                                "borderRight": "solid",
                                "qrCodeLevel": 0,
                                "borderBottom": "solid",
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 317.5,
                                "top": 162.5,
                                "height": 24,
                                "width": 124.5,
                                "field": "totalPaymentAmt",
                                "right": 444.75,
                                "title": "上期欠款",
                                "bottom": 252.75,
                                "hCenter": 240.75,
                                "vCenter": 382.5,
                                "fontSize": 14,
                                "testData": "100009.45",
                                "borderTop": "solid",
                                "hideTitle": true,
                                "textAlign": "center",
                                "borderLeft": "solid",
                                "borderRight": "solid",
                                "qrCodeLevel": 0,
                                "borderBottom": "solid",
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 442.5,
                                "top": 162.5,
                                "height": 24,
                                "width": 124.5,
                                "field": "endBalanceAmt",
                                "right": 567.75,
                                "title": "上期欠款",
                                "bottom": 254.25,
                                "hCenter": 242.25,
                                "vCenter": 505.5,
                                "fontSize": 14,
                                "testData": "100009.45",
                                "borderTop": "solid",
                                "hideTitle": true,
                                "textAlign": "center",
                                "borderLeft": "solid",
                                "borderRight": "solid",
                                "qrCodeLevel": 0,
                                "borderBottom": "solid",
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        },
                        {
                            "options": {
                                "left": 72.5,
                                "top": 162.5,
                                "height": 24,
                                "width": 124.5,
                                "field": "beginBalanceAmt",
                                "right": 198,
                                "title": "上期欠款",
                                "bottom": 255,
                                "hCenter": 243,
                                "vCenter": 135.75,
                                "fontSize": 14,
                                "testData": "100009.45",
                                "borderTop": "solid",
                                "hideTitle": true,
                                "textAlign": "center",
                                "borderLeft": "solid",
                                "borderRight": "solid",
                                "qrCodeLevel": 0,
                                "borderBottom": "solid",
                                "coordinateSync": false,
                                "widthHeightSync": false,
                                "textContentVerticalAlign": "middle"
                            },
                            "printElementType": {
                                "title": "文本",
                                "type": "text"
                            }
                        }
                    ],
                    "paperNumberLeft": 553.5,
                    "paperNumberTop": 18,
                    "paperNumberContinue": true,
                    "watermarkOptions": {}
                }
            ]
        }
    },
}

export default {
    // 应收对账单 -- 不同配送中心打印模板名
    accountReceivableTempOptions,
    // 应收对账单 -- 不同分公司打印模板名json
    accountReceivableTempJsonOptions,
}
